class VideoLooper {
  constructor(videoSelector) {
    this.videos = $(videoSelector).toArray();
    this.currentIndex = 0;
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.videos.forEach((video, index) => {
      $(video).on("ended", () => this.onVideoEnded(index));
    });
  }

  onVideoEnded(index) {
    $(this.videos[index]).fadeOut();
    this.currentIndex = (index + 1) % this.videos.length;
    const nextVideo = this.videos[this.currentIndex];
    $(nextVideo).fadeIn();
    nextVideo.play();
  }

  playFirstVideo() {
    $(this.videos[0]).fadeIn();
    this.videos[0].play();
  }
}